export default "__VITE_ASSET__CJI$gKcf__"